import styled from '@emotion/styled'

import { colors, typo } from '~/@common/styles'

const S = {
  Container: styled.section`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    gap: 6vh;
    .title {
      font-size: 18px;
      font-weight: 700;
      color: #0f172a;
    }

    .contents {
      .tab {
        display: flex;

        border: 1px solid ${colors.gray.$400};
        border-bottom: none;
        overflow: hidden;
      }

      .tab-item {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 54px;
        ${typo.body02}
        cursor: pointer;
        border-bottom: 1px solid ${colors.gray.$400};
        border-right: 1px solid ${colors.gray.$400};

        &:last-child {
          border-right: none;
        }

        &.selected {
          font-weight: 700;
          color: ${colors.gray.$900};
          background-color: ${colors.white};
          border-bottom: none;
          border-top: 2px solid ${colors.gray.$900};
        }
      }

      .form {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 340px;
        padding: 24px;
        background-color: ${colors.white};
        border-left: 1px solid ${colors.gray.$400};
        border-right: 1px solid ${colors.gray.$400};
        border-bottom: 1px solid ${colors.gray.$400};
      }

      .input-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 32px;

        &.id-error {
          gap: 30px;
        }

        &.password-error {
          margin-bottom: 34px;
        }

        .id-input,
        .password-input {
          width: 272px;
          height: 40px;
          border-radius: 4px;

          input {
            ${typo.body02};
            border-radius: 4px;

            &::placeholder {
              ${typo.body02};
              text-align: center;
            }
          }
        }

        .password-input {
          margin-top: 10px;
        }

        .hidden {
          height: 0;
          overflow: hidden;
          opacity: 0;
          transition: all 0.2s ease-in-out;
          margin-top: 0;
        }
      }

      .submit-button {
        width: 100%;
        background-color: var(--Colors-Slate-900);
        color: ${colors.white};
        ${typo.body02};
        font-weight: 700;
        margin-bottom: 16px;
        &.schoolflat {
          background-color: var(--Colors-Blue-600);
        }
      }

      .login-checkbox {
        display: flex;
        align-items: center;
        position: relative;
        gap: 12px;
        ${typo.body02};
        cursor: pointer;
        input[type='checkbox'] {
          width: 20px;
          height: 20px;
          box-sizing: border-box;
          position: absolute;
          inset: 0px;
          margin: 0px;
          opacity: 0;
          z-index: 2;
        }
        .checkbox_label {
          display: block;
          position: relative;
          width: 20px;
          height: 20px;
          border: 1px solid var(--Colors-Gray-500);
          border-radius: 3px;
          background-color: var(--White);
          cursor: pointer;
          &:after {
            position: absolute;
            display: block;
            width: 12px;
            height: 6px;
            border-left: 2px solid var(--White);
            border-bottom: 2px solid var(--White);
            border-top-color: var(--White);
            border-right-color: var(--White);
            left: 3px;
            top: 5px;
            content: '';
            transform: rotate(-45deg);
          }
        }
        input[type='checkbox']:checked + .checkbox_label {
          background-color: var(--Colors-Slate-900);
          border-color: var(--Colors-Slate-900);
        }

        input[type='checkbox']:checked + .checkbox_label:after {
          border-color: var(--White);
        }
      }
    }
  `,
  Guide: styled.section`
    ${typo.caption01};
    margin: 0 auto calc(env(safe-area-inset-bottom) + 16px);
    margin: 0 auto calc(constant(safe-area-inset-bottom) + 16px);
    color: ${colors.gray.$500};
    text-align: center;
  `,
}

export default S
